<template>
  <div class="tungee-head-bar">
    <div class="logo">
      <router-link class="logo-link" to="/"><img src="@/assets/logo-blue.png"></router-link>
    </div>
    <div class="right">
      <div class="link">
        <div class="text"><router-link to="/service">我们的服务</router-link></div>
      </div>
      <div class="link">
        <div class="text">
          <router-link to="/solution">行业解决方案</router-link>
          <div class="triangle"></div>
        </div>
        <div class="container">
          <div class="solution">
            <router-link to="/solutionDetails1">银行业解决方案</router-link>
            <router-link to="/solutionDetails2">企业金融解决方案</router-link>
            <router-link to="/solutionDetails3">保险行业解决方案</router-link>
            <router-link to="/solutionDetails4">地产行业解决方案</router-link>
            <router-link to="/solutionDetails5">能源行业解决方案</router-link>
            <router-link to="/solutionDetails6">智能终端测试解决方案</router-link>
            <router-link to="/solutionDetails7">运营商大数据解决方案</router-link>
            <router-link to="/solutionDetails8">跨境电商解决方案</router-link>
            <router-link to="/solutionDetails9">证券业解决方案</router-link>
            <router-link to="/solutionDetails10">智慧医疗解决方案</router-link>
            <router-link to="/solutionDetails11">智慧康养解决方案</router-link>
            <router-link to="/solutionDetails12">IT基础设施解决方案</router-link>
            <router-link to="/solutionDetails13">智慧物流解决方案</router-link>
            <router-link to="/solutionDetails14">智慧农业解决方案</router-link>
            <router-link to="/solutionDetails15">智慧社区解决方案</router-link>
          </div>
        </div>
      </div>
      <div class="link">
        <div class="text"><router-link to="/afSolutionDetails">汽车金融解决专题</router-link></div>
      </div>
      <div class="link">
        <div class="text"><router-link to="/case">客户案例</router-link></div>
      </div>
      <div class="link">
        <div class="text">
          关于橡诺
          <div class="triangle"></div>
        </div>
        <div class="container">
          <div class="about">
            <router-link to="/about">公司简介</router-link>
            <router-link to="/honor">企业荣誉</router-link>
            <router-link to="/contacts">联系我们</router-link>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
export default {
  name: '',
  props: {
    
  }
}
</script>

<style scoped lang="less">
.tungee-head-bar{
  font-size: 0;
  position: fixed;
  z-index: 999;
  top: 0;
  height: 72px;
  width: 100%;
  line-height: 72px;
  background: #fff;
  -webkit-box-shadow: 0 2px 3px 0 rgba(30,46,65,.1);
  box-shadow: 0 2px 3px 0 rgba(30,46,65,.1);
  // background: linear-gradient(45deg, #00a0e8 10%, #02cef6);
  // background: linear-gradient(45deg, #7574e3 10%, #3f78ef);
  .logo{
    width: 20%;
    padding-left: 64px;
    line-height: 64px;
    height: 64px;
    display: inline-block;
    vertical-align: middle;
    .logo-link img{
      display: inline-block;
      line-height: 56px;
      height: 56px;
      vertical-align: middle;
    }
  }
  .right {
    text-align: right;
    padding-right: 64px;
    height: 100%;
    width: 80%;
    display: inline-block;
    vertical-align: middle;
    .link {
      display: inline-block;
      vertical-align: middle;
      margin-left: 48px;
      text-decoration: none;
      font-size: 16px;
      color: #333;
      letter-spacing: .63px;
      a{
        color: #333;
      }
      a:hover{
        color: #888;
      }
      .text {
        position: relative;
        height: 100%;
        cursor: pointer;
      }
      .text:hover {
        color: #888;
      }
      .triangle {
        display: none;
        position: absolute;
        bottom: -12px;
        width: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        border-color: #fff transparent transparent transparent;
        border-width: 6px;
        border-style: solid;
        z-index: 2;
      }
      .container{
        display: none;
        position: absolute;
        left: 0;
        width: 100%;
        // background: #00a0e8;
        // background: linear-gradient(45deg, #00a0e8 10%, #3f78ef);
        background: linear-gradient(45deg, #00a0e8 10%, #02cef6);
        -webkit-box-shadow: 0 2px 3px 0 rgba(30,46,65,.1);
        box-shadow: 0 2px 3px 0 rgba(30,46,65,.1);
        // -webkit-box-shadow: 0 2px 31px 0 rgba(30,46,65,.45);
        // box-shadow: 0 2px 31px 0 rgba(30,46,65,.45);
        .about{
          text-align: right;
          margin: 0 64px;
          a{
            margin-left: 30px;
            color: #fff;
          }
          a:hover{
            opacity: .5;
          }
        }
        .solution{
          padding: 20px 0;
          margin: 0 auto;
          width: 1200px;
          line-height:50px;
          text-align: left;
          a{
            display: inline-block;
            width: 200px;
            line-height:30px;
            font-size: 14px;
            // margin-left: 30px;
            text-align: center;
            color: #fff;
          }
          a:hover{
            opacity: .5;
          }
        }
      }
      &:hover {
        .triangle {
          display: block;
        }
        .container{
          display: block;
        }
      }
    }
  }
}
</style>
